import { BasePlugin } from '../../core/base-plugin';
import { ReportData } from '../../core/types';
import { PerformanceData } from './types';

export class PerformancePlugin extends BasePlugin {
  public name = 'performance';
  private performanceObserver?: PerformanceObserver;

  public init(): void {
    this.monitorPageLoad();
    this.monitorResourceLoad();
  }

  public destroy(): void {
    this.performanceObserver?.disconnect();
  }

  private monitorPageLoad(): void {
    window.addEventListener('load', () => {
      setTimeout(() => {
        const performance = window.performance;
        if (!performance) return;

        const timing = performance.timing;
        const data: PerformanceData = {
          type: 'performance',
          subType: 'page-load',
          dnsTime: timing.domainLookupEnd - timing.domainLookupStart,
          tcpTime: timing.connectEnd - timing.connectStart,
          whiteScreenTime: timing.domLoading - timing.navigationStart,
          domReadyTime: timing.domContentLoadedEventEnd - timing.navigationStart,
          loadTime: timing.loadEventEnd - timing.navigationStart,
        };

        this.report?.(data);
      }, 0);
    });
  }

  private monitorResourceLoad(): void {
    this.performanceObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries() as PerformanceResourceTiming[];
      entries.forEach((entry) => {
        const data: PerformanceData = {
          type: 'performance',
          subType: 'resource',
          name: entry.name,
          initiatorType: entry.initiatorType,
          duration: entry.duration,
          transferSize: entry.transferSize,
        };
        this.report?.(data);
      });
    });

    this.performanceObserver.observe({ entryTypes: ['resource'] });
  }
} 